import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import { FONT_SIZES } from '../constants';
/**
 * Компонент выбора размера шрифта
 * Отображает список доступных размеров
 */
const FontSizePicker = ({ currentSize, onSizeChange, onClose }) => {
    const handleSizeSelect = (size) => {
        onSizeChange(size);
        onClose();
    };
    return (_jsx("div", { className: "dropdown-menu", children: FONT_SIZES.map((size) => (_jsxs("button", { type: "button", className: `dropdown-item ${currentSize === size ? 'active' : ''}`, onClick: () => handleSizeSelect(size), children: [size, "px"] }, size))) }));
};
export default FontSizePicker;
